const CONTANTS = {
  APP_URL: 'https://app.overlayon.com',

  SUPPORT_EMAIL: 'overlaysstreamon@gmail.com',
};

export default CONTANTS;
